import React, { useEffect, useState } from "react";
import { Box, Tooltip, CircularProgress, Typography } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { getDataFromJson } from "utils/tools";

const LocationStuckField = ({ record }: { record?: any }) => {
  const [isStuck, setIsStuck] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!record?.tripHistoryUrl || record?.status === "Ready") {
      setIsStuck(null);
      return;
    }

    let cancelled = false;

    const checkLocationStuck = async () => {
      setIsLoading(true);
      try {
        const result = await getDataFromJson(record.tripHistoryUrl);

        if (cancelled) return;

        if (!result || !result.json || result.json.length < 60) {
          setIsStuck(null);
          return;
        }

        const data: ITripHistoryItem[] = result.json;

        // Get the 60 latest data points (last 60 items)
        const latest60 = data.slice(-60);

        // Check if all 5 have the same lat and lng
        const firstLat = latest60[0].Lat;
        const firstLng = latest60[0].Lng;
        const stuck = latest60.every(
          (item) => item.Lat === firstLat && item.Lng === firstLng,
        );

        setIsStuck(stuck);
      } catch (error) {
        console.error("Failed to check location stuck:", error);
        if (!cancelled) setIsStuck(null);
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    checkLocationStuck();

    return () => {
      cancelled = true;
    };
  }, [record?.tripHistoryUrl, record?.status]);

  if (isLoading) {
    return <CircularProgress size={16} />;
  }

  if (isStuck === null) {
    return <>-</>;
  }

  if (isStuck) {
    return (
      <Tooltip title="Possibly location is stuck - last 60 data points have the same coordinates">
        <Box style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <WarningIcon style={{ color: "#F57C00", fontSize: "18px" }} />
          <Typography
            variant="body2"
            style={{ color: "#E65100", fontWeight: "bold" }}
          >
            Stuck
          </Typography>
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Location is moving normally">
      <Box style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CheckCircleIcon style={{ color: "#05CD99", fontSize: "18px" }} />
        <Typography variant="body2" style={{ color: "#2B3674" }}>
          OK
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default LocationStuckField;
